var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGritAlertRules(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.75c-.62 0-1.13.5-1.13 1.13v.5A5.88 5.88 0 0 0 6.13 10v2.78l-1.3 2.17a1.13 1.13 0 0 0 .97 1.7h12.4a1.13 1.13 0 0 0 .97-1.7l-1.3-2.17V10a5.88 5.88 0 0 0-4.74-5.62v-.5c0-.63-.51-1.13-1.13-1.13Zm0 2.75A4.5 4.5 0 0 1 16.5 10v2.97c0 .15.04.3.12.43l1.04 1.73H6.34l1.04-1.73c.08-.13.12-.28.12-.43V10A4.5 4.5 0 0 1 12 5.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 18.4a2.2 2.2 0 0 0 4.2 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGritAlertRules);
export default __webpack_public_path__ + "static/media/grit-alert-rules.7420f0d526d6187c714731eb34ac714f.svg";
export { ForwardRef as ReactComponent };